import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RubrikConfigEntry } from '../../../core/base-api';
import { map } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';
import { AppCustomConfigService } from '../../../core/services/app-custom-config.service';
import RubrikEnum = RubrikConfigEntry.RubrikEnum;

@Injectable()
export class RubrikConfigService {
  constructor(private rubrikService: AppCustomConfigService) {}

  static getConfigsFrom(route: ActivatedRoute, rubrikType: RubrikConfigEntry.RubrikEnum) {
    if (rubrikType === RubrikEnum.GB_DETAIL_GRUNDSTUECK) {
      return route.snapshot.data.grundstueck;
    }
    if (rubrikType === RubrikEnum.GB_DETAIL_PFANDRECHT) {
      return route.snapshot.data.pfandrecht;
    }
    if (rubrikType === RubrikEnum.GB_DETAIL_STANDARDRECHT) {
      return route.snapshot.data.standardrecht;
    }
    throw new Error('No resolver implemented');
  }

  loadConfigs(rubrikType: RubrikEnum): Observable<[RubrikConfigEntry, string[]]> {
    const rubrikConfig$ = this.rubrikService
      .getRubrikConfigs()
      .pipe(map((a) => (<Array<RubrikConfigEntry>>a).filter((r) => r.rubrik === rubrikType)[0]));
    const availableComponents$ = this.rubrikService.getRubrikComponents(rubrikType);
    return forkJoin([rubrikConfig$, availableComponents$]);
  }
}
